<style>
a.nav-link {
  font-size: 11px;
}
@media only screen and (max-width: 330px) {
  a.nav-link {
    font-size: 10px;
  }
}
</style>
<template>
  <div id="page">
    <div class="page-content">
      <div class="page-title page-title-small">
        <h2>
          <button @click.prevent="goBack">
            <i class="fa fa-arrow-right"></i></button
          >بستن {{ lableText("TaskName") ?? "وظیفه" }}
        </h2>
        <button
          class="
            bg-fade-gray1-dark
            shadow-xl
            d-flex
            align-items-center
            justify-content-center
            refresh-btn
          "
          @click.prevent="reloadPage"
        >
          <i class="font-16 fa fa-redo"></i>
        </button>
      </div>
      <div class="card header-card shape-rounded" data-card-height="150">
        <div class="card-overlay bg-highlight opacity-95"></div>
        <div class="card-overlay dark-mode-tint"></div>
        <div class="card-bg bg-20"></div>
      </div>

      <div class="card card-style bg-theme pb-0">
        <ul
          class="nav nav-pills mb-4 mx-3 mt-4 justify-content-center"
          id="pills-tab"
          role="tablist"
        >
          <li
            class="nav-item flex-1"
            role="presentation"
            @click="onTabClick('pills-details')"
          >
            <button
              class="nav-link text-center rounded-s w-100"
              :class="{ active: activeTabTitle == '#pills-details' }"
              id="pills-details-tab"
              data-toggle="pill"
              data-target="#pills-details"
              role="tab"
              aria-controls="pills-details"
              aria-selected="true"
              style="border: 1px solid #007bff"
            >
             جزئیات
            </button>
          </li>
          <li
            class="nav-item flex-1"
            role="presentation"
            @click="onTabClick('pills-taskInfo')"
          >
            <button
              class="nav-link text-center rounded-0 w-100"
              :class="{ active: activeTabTitle == '#pills-taskInfo' }"
              id="pills-taskInfo-tab"
              data-toggle="pill"
              data-target="#pills-taskInfo"
              role="tab"
              aria-controls="pills-taskInfo"
              aria-selected="false"
              style="border: 1px solid #007bff"
            >
              {{ lableText("TaskName") ?? "وظیفه" }}
            </button>
          </li>
          <li
            class="nav-item flex-1"
            role="presentation"
            @click="onTabClick('pills-timeLine')"
          >
            <button
              class="nav-link text-center rounded-0 w-100"
              :class="{ active: activeTabTitle == '#pills-timeLine' }"
              id="pills-timeLine-tab"
              data-toggle="pill"
              data-target="#pills-timeLine"
              role="tab"
              aria-controls="pills-timeLine"
              aria-selected="false"
              style="border: 1px solid #007bff"
            >
              سیر زمانی
            </button>
          </li>
          <li
            class="nav-item flex-1" 
            role="presentation"
            @click="onTabClick('pills-taskworklist')"
          >
            <button
              class="nav-link text-center rounded-s w-100"
              :class="{ active: activeTabTitle == '#pills-taskworklist' }"
              id="pills-taskworklist-tab"
              data-toggle="pill"
              data-target="#pills-taskworklist"
              role="tab"
              aria-controls="pills-taskworklist"
              aria-selected="false"
              style="border: 1px solid #007bff"
            >
              پیگیری‌ها
            </button>
          </li>
        </ul>
        <div class="tab-content" id="pills-tabContent">
          <div
            class="tab-pane fade"
            id="pills-details"
            :class="{ 'active show': activeTabTitle == '#pills-details' }"
            role="tabpanel"
            aria-labelledby="pills-details-tab"
          >
            <div class="content mb-0">
              <div class="input-style input-style-2 has-icon input-required">
                <i class="input-icon fa fa-hashtag color-magenta2-light"></i>
                <span class="color-highlight input-style-1-active">{{
                  lableText("TaskNo") ?? "شماره وظیفه"
                }}</span>
                <input
                  class="form-control text-left"
                  type="text"
                  v-model="taskCloseModel.taskNo"
                  readonly
                />
              </div>
              <div class="input-style input-style-2 has-icon input-required">
                <i
                  class="input-icon fa fa-check-square color-magenta2-light"
                ></i>
                <span class="color-highlight input-style-1-active">{{
                  lableText("Title") ?? "عنوان وظیفه"
                }}</span>
                <input
                  class="form-control"
                  type="text"
                  v-model="taskCloseModel.taskTitle"
                  readonly
                />
              </div>
              <div class="input-style input-style-2 has-icon input-required">
                <i
                  class="input-icon fa fa-check-square color-magenta2-light"
                ></i>
                <span class="color-highlight input-style-1-active">موضوع</span>
                <input
                  class="form-control"
                  type="text"
                  v-model="taskCloseModel.subject"
                  readonly
                />
              </div>
              <div class="input-style input-style-2 has-icon input-required">
                <i class="input-icon fa fa-user-check color-magenta2-light"></i>
                <span class="color-highlight input-style-1-active"
                  >بررسی کننده</span
                >
                <input
                  class="form-control"
                  type="text"
                  v-model="taskCloseModel.toUserTitle"
                  readonly
                />
              </div>
              <div class="input-style input-style-2 has-icon input-required">
                <i class="input-icon fa fa-user-plus color-magenta2-light"></i>
                <span class="color-highlight input-style-1-active"
                  >درخواست دهنده</span
                >
                <input
                  class="form-control"
                  type="text"
                  v-model="taskCloseModel.userTitle"
                  readonly
                />
              </div>

              <div class="input-style input-style-2 has-icon input-required">
                <i class="input-icon fa fa-file-alt color-magenta2-light"></i>
                <span class="color-highlight input-style-1-active"
                  >نتیجه بررسی</span
                >
                <select
                  class="form-control"
                  type="text"
                  v-model="taskCloseModel.userActionTypeId"
                  @change="onChangeActionType"
                >
                  <option value="0" disabled>انتخاب کنید...</option>
                  <option value="1">تایید</option>
                  <option value="2">رد</option>
                </select>
                <p
                  class="text-danger"
                  v-if="
                    v$.taskCloseModel.userActionTypeId.required.$invalid &&
                    v$.taskCloseModel.userActionTypeId.$dirty
                  "
                >
                  لطفا نتیجه بررسی را انتخاب کنید.
                </p>
              </div>

              <div class="input-style input-style-2 has-icon input-required">
                <i class="input-icon fa fa-pen color-magenta2-light"></i>
                <span class="color-highlight input-style-1-active">
                  توضیحات نتیجه بررسی</span
                >
                <textarea
                  v-model="taskCloseModel.comment"
                  class="form-control line-height-m text-justify"
                  rows="3"
                  style="height: 200px"
                  @input="v$.taskCloseModel.comment.$touch()"
                  :class="{ invalid: v$.taskCloseModel.comment.$error }"
                ></textarea>
                <p
                  class="text-danger"
                  v-if="
                    v$.taskCloseModel.comment.required.$invalid &&
                    v$.taskCloseModel.comment.$dirty
                  "
                >
                  لطفا توضیحات را وارد کنید.
                </p>
                <p
                  class="text-danger"
                  v-if="
                    v$.taskCloseModel.comment.maxLength.$invalid &&
                    v$.taskCloseModel.comment.$dirty
                  "
                >
                  توضیحات نباید بیشتر از ۲۰۰ کاراکتر باشد.
                </p>
              </div>

              <p>آخرین پیگیری :</p>
              <div class="input-style input-style-2 has-icon input-required">
                <i
                  class="input-icon fa fa-check-square color-magenta2-light"
                ></i>
                <span class="color-highlight input-style-1-active"
                  >زمان ثبت</span
                >
                <input
                  class="form-control"
                  type="text"
                  v-model="taskCloseModel.lastWork_CreateDateTime"
                  readonly
                />
              </div>
              <div class="input-style input-style-2 has-icon input-required">
                <i
                  class="input-icon fa fa-check-square color-magenta2-light"
                ></i>
                <span class="color-highlight input-style-1-active"
                  >زمان استفاده شده</span
                >
                <input
                  class="form-control"
                  type="text"
                  v-model="taskCloseModel.lastWork_WorkUsedTime"
                  readonly
                />
              </div>
              <div class="card card-style mx-0 mb-3">
                <div
                  class="
                    list-group list-custom-small list-icon-0
                    bg-blue1-dark
                    px-2
                    collapse-description-box
                  "
                >
                  <a
                    class="pr-1"
                    data-toggle="collapse"
                    href="#collapse-description2"
                  >
                    <i class="fa fa-edit mt-2"></i>
                    <span>شرح پیگیری</span>
                    <i class="fa fa-angle-down"></i>
                  </a>
                </div>
                <div
                  class="collapse collapse-reminderCalendars"
                  id="collapse-description2"
                >
                  <div
                    class="
                      form-control
                      font-12
                      line-height-m
                      text-justify
                      div-description
                      px-2
                    "
                    v-html="taskCloseModel.lastWork_Desc"
                    style="height: 200px"
                    readonly
                  ></div>
                  <!--<textarea  v-model="taskCloseModel.lastWorkDesc" class="form-control line-height-m text-justify" rows="3" style="height:200px"></textarea>-->
                </div>
              </div>

              <button
                v-if="taskCloseModel.canConfirm == true"
                :disabled="Loading"
                class="
                  btn btn-xxs
                  mt-2
                  mb-4
                  btn-full
                  bg-green1-dark
                  rounded-sm
                  font-900
                  w-100
                "
                @click.prevent="UpdateCloseRequest"
              >
                <i class="fa fa-check font-10 ml-2"></i>
                ثبت
              </button>
            </div>
          </div>
          <div
            class="tab-pane fade"
            id="pills-taskInfo"
            :class="{ 'active show': activeTabTitle == '#pills-taskInfo' }"
            role="tabpanel"
            aria-labelledby="pills-taskInfo-tab"
          >
            <task-info
              v-if="taskCloseModel.taskId != null"
              :taskId="taskCloseModel.taskId"
              :taskFolderId="taskCloseModel.taskFolderId"
            ></task-info>
          </div>
          <div
            class="tab-pane fade"
            id="pills-timeLine"
            :class="{ 'active show': activeTabTitle == '#pills-timeLine' }"
            role="tabpanel"
            aria-labelledby="pills-timeLine-tab"
          >
            <task-time-line
              v-if="taskCloseModel.taskId != null"
              :taskId="taskCloseModel.taskId"
              :taskFolderId="taskCloseModel.taskFolderId"
            ></task-time-line>
          </div>
          <div
            class="tab-pane fade"
            id="pills-taskworklist"
            :class="{ 'active show': activeTabTitle == '#pills-taskworklist' }"
            role="tabpanel"
            aria-labelledby="pills-taskworklist-tab"
          >
            <task-work-list
              v-if="taskCloseModel.taskId != null"
              :taskId="taskCloseModel.taskId"
              :taskFolderId="taskCloseModel.taskFolderId"
            ></task-work-list>
          </div>
        </div>
      </div>
    </div>
    <transition
      enter-active-class="animated fadeInUp"
      leave-active-class="animated fadeOutDown"
    >
      <div
        v-if="Loading"
        class="w-100 d-flex justify-content-center loadingBox"
      >
        <div
          class="
            toast-tiny toast-bottom
            bg-magenta1-light
            fade
            show
            text-center
            font-10
          "
        >
          <i class="fa fa-sync fa-spin ml-3"></i>درحال ارسال اطلاعات ...
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { required, maxLength } from "@vuelidate/validators";
import taskInfo from "./TaskInfo.vue";
import timeLine from "./TimeLine.vue";
import taskWorkList from "./TaskWorkList.vue";
import VueSimpleAlert from "vue3-simple-alert";

export default {
  components: {
    "task-info": taskInfo,
    "task-time-line": timeLine,
    "task-work-list": taskWorkList,
  },
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      showTaskInfoModal: false,
      activeTabTitle: "#pills-details",
      modified: false,
      taskCloseModel: {
        closeRequestId: this.$route.params.closeRequestId,
        taskId: null,
        taskFolderId: null,
        subject: null,
        taskNo: null,
        taskFolderTitle: null,
        userActionTypeId: 1,
        userTitle: null,
        toUserTitle: null,
        comment: null,
        canConfirm: null,
        lastWork_CreateDateTime: null,
        lastWork_WorkUsedTime: null,
        lastWork_Desc: null,
        taskTitle: null,
      },
    };
  },
  computed: {
    Loading() {
      return this.$store.getters.GetLoading;
    },
  },
  created() {
    var activeTabTitle = location.hash;
    if (activeTabTitle != "") {
      this.activeTabTitle = activeTabTitle;
    }
    this.getTaskCloseData();
    setTimeout(function () {
      document.getElementsByClassName("menu-hider")[0].click();
    });
  },
  methods: {
    UpdateCloseRequest() {
      this.v$.$touch(); //it will validate all fields
      if (!this.v$.$invalid) {
        //invalid, becomes true when a validations return false
        this.$store.dispatch("UpdateCloseRequest", this.taskCloseModel);
      }
    },
    getTaskCloseData() {
      this.$http
        .get(
          "TaskCloseRequest/CloseTask?id=" + this.taskCloseModel.closeRequestId
        )
        .then((data) => {
          this.taskCloseModel = data.data;
        });
    },
    onChangeActionType() {
      if (this.taskCloseModel.userActionTypeId == "1") {
        this.taskCloseModel.comment = "با سلام و احترام درخواست شما تایید شد";
      } else if (this.taskCloseModel.userActionTypeId == "2") {
        this.taskCloseModel.comment = "با سلام و احترام درخواست شما رد شد";
      }
    },
    onTabClick(title) {
      console.log(title);
    },
  },
  validations: {
    taskCloseModel: {
      userActionTypeId: {
        required,
      },
      comment: {
        required,
        maxLength: maxLength(200),
      },
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.modified == true) {
      VueSimpleAlert.fire({
        title:
          "با بستن این صفحه تغییرات شما ذخیره نخواهد شد. آیا ادامه می دهید؟",
        showCancelButton: true,
        confirmButtonText: "تأیید",
        cancelButtonText: `انصراف`,
      }).then((result) => {
        console.log(this.modified);

        if (result.value == true) {
          next();
        } else {
          next(false);
        }
      });
    } else {
      next();
    }
  },
};
</script>
